<div class="page">
  <div class="container">
    <figure fd-illustrated-message [svgConfig]="config()">
      <figcaption fd-illustrated-message-figcaption>
        <h3
          fd-illustrated-message-title
          [innerHTML]="config().illustratedMessageTitle"
        ></h3>
        <p
          fd-illustrated-message-text
          [innerHTML]="config().illustratedMessageText"
        ></p>
      </figcaption>
      <fd-illustrated-message-actions>
        <button
          fd-button
          label="Open as tab"
          [fdCompact]="true"
          (click)="goTo(extensionUrl())"
        ></button>
      </fd-illustrated-message-actions>
    </figure>
  </div>
</div>
